import { useEffect, useRef } from 'react';
import { useSearchParams } from 'react-router';

/**
 * Abre um formulário quando a URL chega com `?novo=1` (ação "Novo redirecionador" da busca)
 * e limpa o parâmetro em seguida — recarregar a página não reabre o formulário.
 */
export function useOpenFromParam(param: string, open: () => void, enabled = true): void {
  const [params, setParams] = useSearchParams();
  const openRef = useRef(open);
  openRef.current = open;
  const flag = params.get(param);

  useEffect(() => {
    if (!enabled || flag !== '1') return;
    openRef.current();
    setParams(
      (current) => {
        const next = new URLSearchParams(current);
        next.delete(param);
        return next;
      },
      { replace: true },
    );
  }, [enabled, flag, param, setParams]);
}
